__webpack_require__.p = "/wp-content/themes/sciencenews-sns-child/client/build/";